import React, { CSSProperties, FC } from 'react'

/** Dual-sparkle icon used for AI features (Spec Intelligence, AI Disclaimer, etc.). */
const AIIcon: FC<{ className?: string; style?: CSSProperties }> = ({ className = '', style }) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        className={className}
        style={style}
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        data-testid="ai-icon"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.88 5.76003C15.2872 5.76003 15.645 6.02996 15.7569 6.42148L16.7458 9.88244C17.1786 11.3973 18.3627 12.5814 19.8776 13.0143L23.3385 14.0031C23.7301 14.115 24 14.4728 24 14.88C24 15.2872 23.7301 15.6451 23.3385 15.7569L19.8776 16.7458C18.3627 17.1786 17.1786 18.3627 16.7458 19.8776L15.7569 23.3386C15.645 23.7301 15.2872 24 14.88 24C14.4728 24 14.115 23.7301 14.0031 23.3386L13.0142 19.8776C12.5814 18.3627 11.3973 17.1786 9.88243 16.7458L6.42146 15.7569C6.02994 15.6451 5.76001 15.2872 5.76001 14.88C5.76001 14.4728 6.02994 14.115 6.42146 14.0031L9.88243 13.0143C11.3973 12.5814 12.5814 11.3973 13.0142 9.88244L14.0031 6.42148C14.115 6.02996 14.4728 5.76003 14.88 5.76003Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.28 0C5.51574 0 5.72292 0.156276 5.78768 0.382947L6.36017 2.38666C6.61075 3.26369 7.2963 3.94924 8.17333 4.19982L10.177 4.77231C10.4037 4.83707 10.56 5.04425 10.56 5.28C10.56 5.51574 10.4037 5.72292 10.177 5.78768L8.17333 6.36017C7.2963 6.61075 6.61075 7.2963 6.36017 8.17333L5.78768 10.177C5.72292 10.4037 5.51574 10.56 5.28 10.56C5.04425 10.56 4.83707 10.4037 4.77231 10.177L4.19982 8.17333C3.94924 7.2963 3.26369 6.61075 2.38666 6.36017L0.382947 5.78768C0.156276 5.72292 0 5.51574 0 5.28C0 5.04425 0.156276 4.83707 0.382947 4.77231L2.38666 4.19982C3.26369 3.94924 3.94924 3.26369 4.19982 2.38666L4.77231 0.382947C4.83707 0.156276 5.04425 0 5.28 0Z"
        />
    </svg>
)

export default AIIcon
